import { render, staticRenderFns } from "./NavMenuSection.vue?vue&type=template&id=133a2592&scoped=true&"
import script from "./NavMenuSection.vue?vue&type=script&lang=js&"
export * from "./NavMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuSection.vue?vue&type=style&index=0&id=133a2592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a2592",
  null
  
)

export default component.exports